<div
  id="sliderParent"
  class="sliderParent center m-auto d-width-80 flex-container"
  *ngIf="!isMobileView"
>
  <div class="divWhiteBackground">
    <div role="presentation" tabindex="0">
      <div class="cacImageDiv">
        <img
          class="cacImage"
          alt=""
          width="auto"
          height="48px"
          src="assets/images/CA_Logo.svg"
        />
      </div>
    </div>
    <div *ngIf="notShowingErrorPage" (click)="navigateToHome()">
      <img class="closeButton" alt="" src="assets/images/icn_close.png" />
    </div>
  </div>
  <div *ngIf="notShowingErrorPage">
    <div></div>
  </div>
</div>
<capq-marketing-content
  *ngIf="!isMobileView && notShowingErrorPage"
></capq-marketing-content>
<div class="connecting-line" *ngIf="!isMobileView && notShowingErrorPage"></div>
<div class="sliderParent center heading" *ngIf="isMobileView">
  <div>
    <div role="presentation" tabindex="0" class="d-flex justify-content-center">
      <div class="cacImageDiv">
        <img
          class="cacImage"
          alt=""
          width="auto"
          height="48px"
          src="assets/images/CA_Logo.svg"
        />
      </div>
    </div>
    <div *ngIf="notShowingErrorPage" (click)="navigateToHome()">
      <img class="closeButton" alt="" src="assets/images/icn_close.png" />
    </div>
  </div>
  <ng-container *ngIf="notShowingErrorPage">
    <capq-marketing-content></capq-marketing-content>
    <div class="connecting-line"></div>
    <div class="wizard-inner"></div>
  </ng-container>
</div>
